import { useState, useRef, useEffect } from 'react';

const CustomSelect = ({
	value = '',
	onChange = () => {},
	options = [],
	placeholder = 'Select',
	className = '',
	disabled = false,
	width = '160px',
	fullWidth = false,
}) => {
	const [open, setOpen] = useState(false);
	const ref = useRef();

	const selectedLabel = options.find((opt) => opt.value === value)?.label || placeholder;

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div
			className={`vayu-custom-select ${open ? 'open' : ''} ${className}`}
			ref={ref}
			style={{
				width: fullWidth ? '100%' : width,
				opacity: disabled ? 0.6 : 1,
				pointerEvents: disabled ? 'none' : 'auto',
			}}
		>
			<div className="vayu-select-button" onClick={() => !disabled && setOpen(!open)}>
				<span>{selectedLabel}</span>
				<span className="vayu-arrow">{open ? '▲' : '▼'}</span>
			</div>
			{open && (
				<div className="vayu-select-options">
					{options.map((opt) => (
						<div
							key={opt.value}
							className={`vayu-option ${value === opt.value ? 'active' : ''}`}
							onClick={() => {
								onChange(opt.value);
								setOpen(false);
							}}
						>
							{opt.label}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default CustomSelect;
